export default function DeleteIcon({
  width,
  height,
}: {
  width?: string | number;
  height?: string | number;
}) {
  return (
    <svg
      width={width||"28"}
      height={height||"28"}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 6H16.5C16.5 4.61929 15.3807 3.5 14 3.5C12.6193 3.5 11.5 4.61929 11.5 6ZM10 6C10 3.79086 11.7909 2 14 2C16.2091 2 18 3.79086 18 6H24.25C24.6642 6 25 6.33579 25 6.75C25 7.16421 24.6642 7.5 24.25 7.5H22.9401L21.7233 22.1029C21.5398 24.3057 19.6984 26 17.488 26H10.5123C8.3019 26 6.46053 24.3057 6.27695 22.103L5.05991 7.5H3.75C3.33579 7.5 3 7.16421 3 6.75C3 6.33579 3.33579 6 3.75 6H10ZM7.77177 21.9784C7.89055 23.4037 9.08203 24.5 10.5123 24.5H17.488C18.9183 24.5 20.1097 23.4037 20.2285 21.9784L21.4349 7.5H6.56511L7.77177 21.9784ZM11.75 11C12.1642 11 12.5 11.3358 12.5 11.75V20.25C12.5 20.6642 12.1642 21 11.75 21C11.3358 21 11 20.6642 11 20.25V11.75C11 11.3358 11.3358 11 11.75 11ZM17 11.75C17 11.3358 16.6642 11 16.25 11C15.8358 11 15.5 11.3358 15.5 11.75V20.25C15.5 20.6642 15.8358 21 16.25 21C16.6642 21 17 20.6642 17 20.25V11.75Z"
        fill="currentColor"
      />
    </svg>
  );
}
